import React from 'react';
import PropTypes from 'prop-types';
import Label from '../shared/Label';
import { HeaderTableWrapper } from './styles';

const HeaderTable = ({
  title,
  bgColor,
  height,
  margin,
  size,
}) =>
  (
    <HeaderTableWrapper
      bgColor={bgColor}
      height={height}
      margin={margin}
    >
      <Label
        label={title}
        size={size}
        margin="0 0 0 10px"
        weight="bold"
        isCapitalize
        height={height}
      />
    </HeaderTableWrapper>
  );

HeaderTable.propTypes = {
  title: PropTypes.string,
  bgColor: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  size: PropTypes.any,
};

export default HeaderTable;



// WEBPACK FOOTER //
// ./src/components/HeaderTable/index.js